export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl p-8 md:p-12 lg:p-16 flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-smartphone-line"></i>
              APP
            </div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">移动客户端</h2>
            <p className="text-foreground-600 text-sm md:text-base mb-6 leading-relaxed">
              香蕉动漫移动客户端专为漫画阅读打造，支持离线下载、夜间模式、阅读进度同步。更流畅的下拉式阅读体验，更智能的个性化推荐，随时随地畅享万部免费漫画。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </a>
            </div>
          </div>
          <div className="shrink-0">
            <div className="relative">
              <div className="absolute -inset-6 bg-primary-500/8 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20manga%20reader%20app%20interface%20with%20comic%20panels%2C%20warm%20lighting%2C%20modern%20flat%20UI%20design%2C%20clean%20minimalist%20aesthetic%2C%20soft%20orange%20and%20coral%20accents&width=600&height=800&seq=app-mockup-01&orientation=portrait"
                alt="香蕉动漫移动端界面"
                className="relative w-48 md:w-56 lg:w-64 object-contain"
                onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}